// extracted by mini-css-extract-plugin
export default {"wrapper":"Wrapper_wrapper__GC3yJ","wrapper_title":"Wrapper_wrapper_title__Ll8uQ"};